import { ThemeProvider, useTheme } from '@material-ui/core/styles'
import React from 'react'

// Procurement-only casing rule ("no caps at all, everything small"): force the
// WHOLE procurement section to lowercase — headings, labels, table data, buttons,
// tabs, the lot. We must NOT touch the rest of Alfred (it keeps its look), so this
// is scoped two ways:
//   1. A wrapping element with `textTransform: 'lowercase'`. CSS text-transform
//      inherits, so every descendant that doesn't set its own value is lowercased.
//   2. MUI v4 sets its OWN `textTransform: 'uppercase'` on MuiButton + MuiTab,
//      which would block the inherited lowercase — so we override those two to
//      'lowercase' in a nested theme. (No other MUI component sets text-transform.)
// Net: proper nouns like "MG Road" also render lowercase — intended (Avengers #13).
const ProcurementThemeProvider = ({ children }) => {
  const outer = useTheme()
  const theme = React.useMemo(
    () => ({
      ...outer,
      overrides: {
        ...outer.overrides,
        MuiButton: {
          ...(outer.overrides && outer.overrides.MuiButton),
          root: {
            ...(outer.overrides &&
              outer.overrides.MuiButton &&
              outer.overrides.MuiButton.root),
            textTransform: 'lowercase'
          }
        },
        MuiTab: {
          ...(outer.overrides && outer.overrides.MuiTab),
          root: {
            ...(outer.overrides &&
              outer.overrides.MuiTab &&
              outer.overrides.MuiTab.root),
            textTransform: 'lowercase'
          }
        }
      }
    }),
    [outer]
  )
  return (
    <ThemeProvider theme={theme}>
      <div style={{ textTransform: 'lowercase' }}>{children}</div>
    </ThemeProvider>
  )
}

export default ProcurementThemeProvider
